import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-card-price-calculation" }
const _hoisted_2 = { class: "product-card-price-calculation__content" }
const _hoisted_3 = { class: "cost-container" }
const _hoisted_4 = { class: "cost-item" }
const _hoisted_5 = { class: "cost-value" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "cost-item" }
const _hoisted_8 = { class: "cost-value" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "cost-item" }
const _hoisted_11 = { class: "cost-value" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "cost-item" }
const _hoisted_14 = { class: "cost-value" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 0,
  class: "cost-item"
}
const _hoisted_17 = { class: "cost-value" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 1,
  class: "cost-item"
}
const _hoisted_20 = { class: "cost-value" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "cost-item" }
const _hoisted_23 = {
  key: 0,
  class: "cost-label"
}
const _hoisted_24 = {
  key: 1,
  class: "cost-label"
}
const _hoisted_25 = { class: "cost-value" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "cost-item color-primary" }
const _hoisted_28 = { class: "cost-value" }
const _hoisted_29 = ["innerHTML"]

import {
  computed,
  PropType, ref,
} from 'vue';

import { Product } from '@/classes';
import { formatNumber } from '@/helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceCalculation',
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const productToUse = ref<Product>(props.product);
const { price } = productToUse.value;

const fixedBonus = productToUse.value.getSummedBonus('fixed');
const fixedBonusValue = fixedBonus?.valueGrossFormatted;

const formattedWorkingPriceTotal = computed(() => {
  const workingPrice = price?.mapped.active.workingPriceGross ?? 0;
  const usage = price?.params.usage ?? 0;
  const total = (workingPrice * usage).toFixed(2);

  return formatNumber(parseFloat(total), 2);
});

const formattedBasePriceTotal = computed(() => formatNumber((props.product.price?.mapped.active.basePriceGross ?? 0) * 12, 2));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "title" }, "Information zur Preisberechnung", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "cost-label" }, "Verbrauchsannahme", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              innerHTML: `${__props.product.priceUsageFormatted} kWh`
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "cost-label" }, "× Arbeitspreis", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              innerHTML: `${__props.product.getPriceFormatted('workingPrice')} Cent/kWh`
            }, null, 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "cost-label" }, "= Arbeitspreis gesamt", -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", {
              innerHTML: `${formattedWorkingPriceTotal.value} €/Jahr`
            }, null, 8, _hoisted_12)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "cost-label" }, "+ Grundpreis", -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", {
              innerHTML: `${formattedBasePriceTotal.value} €/Jahr`
            }, null, 8, _hoisted_15)
          ])
        ]),
        (_unref(fixedBonus))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "cost-label" }, [
                _createElementVNode("b", null, "= Jahreskosten")
              ], -1)),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("b", null, [
                  _createElementVNode("span", {
                    innerHTML: `${_unref(formatNumber)(_unref(price)?.mapped.active.yearlyGross, 2)} €/Jahr`
                  }, null, 8, _hoisted_18)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(fixedBonus))
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "cost-label" }, "− Bonus (Einmalig)", -1)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", {
                  innerHTML: `${ _unref(fixedBonusValue) } €`
                }, null, 8, _hoisted_21)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          (_unref(fixedBonus))
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[6] || (_cache[6] = [
                _createElementVNode("b", null, "= Jahreskosten abzgl. Bonus", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[7] || (_cache[7] = [
                _createElementVNode("b", null, "= Jahreskosten", -1)
              ]))),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("b", null, [
              _createElementVNode("span", {
                innerHTML: `${__props.product.getPriceFormatted('yearly')} €/Jahr`
              }, null, 8, _hoisted_26)
            ])
          ])
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "cost-item" }, [
          _createElementVNode("div", { class: "cost-label" }, "÷ 12 Monate")
        ], -1)),
        _cache[10] || (_cache[10] = _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("hr", { class: "color-primary" })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_27, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "cost-label" }, [
            _createElementVNode("b", null, "= Monatskosten")
          ], -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("b", null, [
              _createElementVNode("span", {
                innerHTML: `${_unref(formatNumber)(__props.product.getPriceValue('monthly'), 2)} €/Monat`
              }, null, 8, _hoisted_29)
            ])
          ])
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("p", null, " Sie zahlen 12 Abschläge, die sich an Ihrem realen Verbrauch orientieren. Der hier dargestellte, geschätzte Wert dient nur zu Ihrer Orientierung. ", -1))
    ])
  ]))
}
}

})